import { memo } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "next-i18next";
import { getCloudfrontUrl } from "../utils/mediaHelper";
import Link from "next/link";
import Image from "next/image";

const RecentNewsSection = memo(
  ({ recentNews = [], loading, className = "" }) => {
    const { t } = useTranslation("news");

    return (
      <section
        className={`w-full flex flex-col items-center justify-start px-6 sm:px-6 lg:px-20 pb-[40px] lg:pb-[60px] box-border text-text-primary  ${className}`}
      >
        <div className="w-full flex flex-col items-start gap-6 lg:gap-10">
          {/* Heading Row */}
          <div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <h2 className="text-[28px] sm:text-[32px] lg:text-[40px] font-medium leading-[120%] m-0">
              {t("news.recentNews")}
            </h2>
            <Link
              className="no-underline rounded-[50px] bg-crimson text-white text-[16px] font-medium py-3 px-6 cursor-pointer hover:bg-[#e72c46] transition duration-300 ease-in-out"
              href="/news"
            >
              {t("news.btnTxt")}
            </Link>
          </div>

          {/* Main News Content */}
          {loading ? (
            <div className="w-full flex justify-center items-center py-20">
              <ClipLoader color="#EF4444" size={48} />
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
              {recentNews?.map((news, index) => (
                <Link
                  href={`/news/${news?.slug}`}
                  className="block no-underline text-inherit"
                  key={`recent-news-${index}`}
                >
                  <div className="bg-white rounded-[20px] overflow-hidden shadow-md cursor-pointer flex flex-col transition-transform hover:scale-[1.02]">
                    <div className="relative w-full aspect-[1200/630] overflow-hidden rounded-t-[20px] bg-gray-50">
                      <Image
                        src={getCloudfrontUrl(
                          news?.coverImage || "/blog-posts@3x.png",
                        )}
                        alt={news?.title || "News cover"}
                        fill
                        className="object-contain object-center"
                        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                        priority={index < 2}
                      />
                    </div>
                    <div className="p-4 flex flex-col gap-2">
                      <h3 className="text-[15px] font-semibold leading-[140%] text-text-primary m-0">
                        {news?.title}
                      </h3>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    );
  },
);

export default RecentNewsSection;
